<template>
<div>
  <div class="sub_visual_wrap">
      <div class="sub_visual_box container">
          <h2>{{$t('common.error')}}</h2>
      </div>
  </div>
  <section class="sub_contents_wrap container text-center">
      <h3>{{$t('common.WrongAccess')}}</h3>
      <h3 style="margin-bottom: 30px;">{{$t('common.pleaseContactToManager')}}</h3>
      <router-link to="/main" @click.native="$store.commit('setActive','')" class="btn btn-primary">{{$t('common.main')}}</router-link>
  </section>
</div>
</template>

<script>
export default {

}
</script>

<style>

</style>

